import {
  AccountManagerColumn,
} from '../../../../sources/charting_library.min';
import {
  StandardFormatterName,
} from '../../../../sources/charting_library';
import { ITVPosition } from './types';

type TCustomizedAccountManagerColumn =
  AccountManagerColumn & { property: keyof ITVPosition }

export const positionsTableColumns: TCustomizedAccountManagerColumn[] = [
  {
    id: 'name',
    label: 'Symbol',
    formatter: StandardFormatterName.Symbol,
    property: 'name',
    dataFields: ['name', 'name'],
  },
  {
    id: 'segment',
    label: 'Exchange',
    property: 'segment',
    dataFields: ['segment'],
  },
  {
    id: 'side',
    label: 'Side',
    property: 'side',
    formatter: StandardFormatterName.Side,
    dataFields: ['side'],
  },
  {
    id: 'product_type',
    label: 'Product',
    property: 'product_type',
    dataFields: ['product_type'],
  },
  {
    id: 'netQty',
    label: 'Net Qty',
    property: 'netQty', // Total Buy- Total Sell Qty for same symbol,
    alignment: 'right',
    dataFields: ['netQty'],
  },
  {
    id: 'avg_trade_price',
    label: 'Avg trade price', // Average trade price for all qty traded
    property: 'avg_trade_price',
    alignment: 'right',
    sortProp: 'avgPrice',
    dataFields: ['avg_trade_price'],
  },
  {
    id: 'ltp',
    label: 'LTP',
    property: 'ltp',
    alignment: 'right',
    sortProp: 'ltpSortProp',
    dataFields: ['ltp'],
  },
  {
    id: 'realised_pnl',
    label: 'Realised P&L', // Total realised profit post all transactions
    property: 'realised_pnl',
    alignment: 'right',
    sortProp: 'realisedPnlSortProp',
    dataFields: ['realised_pnl'],
  },
  {
    id: 'unrealised_pnl',
    label: 'Unrealised P&L',
    property: 'unrealised_pnl',
    alignment: 'right',
    sortProp: 'pnl',
    dataFields: ['unrealised_pnl'],
  },
];
